import { BaseModel } from '@core/data-access';
import { Exclude, Expose, Type } from 'class-transformer';
import { LeadBusinessType, LeadIndustry, LeadSalutation, PreferredContactMode } from '../type/lead.type';
import { UploadFileControl, UploadFileModel } from '@portal/upload-file/data-access';
import { MultiAttachmentModel } from '@portal/application/data-access';

@Exclude()
export class LeadModel extends BaseModel {
  @Expose() contactEmail!: string;
  @Expose() contactPhoneAreaCode!: string;
  @Expose() contactPhoneNumber!: string;
  @Expose() @Type(() => Number) averageMonthlySales!: number;
  @Expose() industry!: LeadIndustry;
  @Expose() contactSalutation!: LeadSalutation;
  @Expose() contactName!: string;
  @Expose() companyName!: string;
  @Expose() uen!: string;
  @Expose() businessType!: LeadBusinessType;
  @Expose() promoCode!: string;
  @Expose() preferredContactMode!: PreferredContactMode[];
  @Expose() marketingConsent!: boolean;
  @Expose() @Type(() => MultiAttachmentModel) attachment!: MultiAttachmentModel;
}

@Exclude()
export class LeadFormModel extends BaseModel {
  @Expose() contactEmail!: string;
  @Expose() contactPhoneAreaCode!: string;
  @Expose() contactPhoneNumber!: string;
  @Expose() @Type(() => Number) averageMonthlySales!: number;
  @Expose() industry!: LeadIndustry;
  @Expose() contactSalutation!: LeadSalutation;
  @Expose() contactName!: string;
  @Expose() companyName!: string;
  @Expose() uen!: string;
  @Expose() businessType!: LeadBusinessType;
  @Expose() promoCode!: string;
  @Expose() preferredContactMode!: { [k in PreferredContactMode]?: boolean };
  @Expose() marketingConsent!: boolean;

  @Expose()
  @Type(() => Map<string, UploadFileModel>)
  files?: UploadFileControl;
}
